// extracted by mini-css-extract-plugin
export var brand = "_7o-9";
export var compact = "_7o-6";
export var extraSmall = "_7o-7";
export var icon = "_7o-0";
export var large = "_7o-4";
export var light = "_7o-1";
export var medium = "_7o-5";
export var outline = "_7o-b";
export var primaryDark = "_7o-a";
export var primaryLight = "_7o-8";
export var primaryModern = "_7o-c";
export var success = "_7o-2";
export var successSolid = "_7o-3";